import { TekReview } from '@teko-ui/review';
import { ConvertedProduct } from 'types';
import { t } from 'i18n';
import { useTheme, Modal, styled } from '@teko/ds-desktop';
import { useTenantConfig } from 'hooks';
import { useAuth } from '@teko/auth-react';
import { useState } from 'react';
import { BlockHeader, BlockHeaderProps } from '@teko/teko-ecommerce';

interface ReviewSectionProps {
  product: ConvertedProduct;
  wrapperBorderRadius?: string;
}

export const ReviewSection = ({
  product,
  wrapperBorderRadius,
}: ReviewSectionProps) => {
  const { colors, borderRadius } = useTheme();
  const { tekReviewAppId } = useTenantConfig();
  const { user, authService } = useAuth();
  const [show, setShow] = useState(false);

  if (!tekReviewAppId) {
    return null;
  }

  return (
    <Wrapper wrapperBorderRadius={wrapperBorderRadius}>
      <StyledBlockHeader title="Đánh giá sản phẩm" borderColor="#ebeaea" />
      <TekReview
        appId={tekReviewAppId}
        entity={{
          key: product.sku,
          imageUrl: product.images?.[0]?.src || '',
          title: product.name,
        }}
        theme={{
          colors: {
            primary: colors.primary,
            primaryActive: colors.primary600,
            primaryHover: colors.primary700,
          },
          borderRadius: borderRadius.s,
        }}
        reviewer={
          user
            ? {
                displayName: user.name,
                avatarUrl: user.avatar,
                email: user.email,
                phoneNumber: user.telephone,
              }
            : undefined
        }
        onRequestLogin={() => setShow(true)}
      />
      <Modal
        visible={show}
        title={t('Đăng nhập')}
        okText={t('Đăng nhập')}
        cancelText={t('Hủy')}
        onOk={() => {
          authService?.login(window.location.href);
        }}
        onCancel={() => {
          setShow(false);
        }}
        footer={true}
        onBackDrop={() => setShow(false)}
      >
        {t('Vui lòng đăng nhập để đánh giá sản phẩm.')}
      </Modal>
    </Wrapper>
  );
};

const Wrapper = styled.div(
  ({ wrapperBorderRadius }: { wrapperBorderRadius?: string }) => `
  position: relative;
  background-color: #fff;
  margin-top: 8px;
  margin-bottom: 0.5rem;
  border-radius: ${wrapperBorderRadius || '0px'};
`,
);

const StyledBlockHeader = styled(BlockHeader)<
  BlockHeaderProps & { borderColor: string }
>`
  border-bottom: 1px solid ${(props) => props.borderColor};
  .title {
    padding: 0 8px;
  }
`;
